/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One saved version of a plugin mapping, as listed in its change history
 * @export
 * @interface PluginMappingChangeResponse
 */
export interface PluginMappingChangeResponse {
    /**
     * 
     * @type {Date}
     * @memberof PluginMappingChangeResponse
     */
    createdAt: Date;
    /**
     * The earlier version this one was restored from, if it was created by a restore
     * @type {string}
     * @memberof PluginMappingChangeResponse
     */
    restoredFromId: string | null;
    /**
     * Back office user id that saved this version; null if not known
     * @type {string}
     * @memberof PluginMappingChangeResponse
     */
    changedBy: string | null;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PluginMappingChangeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PluginMappingChangeResponse
     */
    pluginId: string;
}

/**
 * Check if a given object implements the PluginMappingChangeResponse interface.
 */
export function instanceOfPluginMappingChangeResponse(value: object): value is PluginMappingChangeResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('restoredFromId' in value) || value['restoredFromId'] === undefined) return false;
    if (!('changedBy' in value) || value['changedBy'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('pluginId' in value) || value['pluginId'] === undefined) return false;
    return true;
}

export function PluginMappingChangeResponseFromJSON(json: any): PluginMappingChangeResponse {
    return PluginMappingChangeResponseFromJSONTyped(json, false);
}

export function PluginMappingChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginMappingChangeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'restoredFromId': json['restoredFromId'],
        'changedBy': json['changedBy'],
        'id': json['id'],
        'pluginId': json['pluginId'],
    };
}

export function PluginMappingChangeResponseToJSON(value?: PluginMappingChangeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'restoredFromId': value['restoredFromId'],
        'changedBy': value['changedBy'],
        'id': value['id'],
        'pluginId': value['pluginId'],
    };
}

